// extracted by mini-css-extract-plugin
export default {"root":"SuspendedNotice_root__aRMd+","compact":"SuspendedNotice_compact__ikCb-","text":"SuspendedNotice_text__KK09B","link":"SuspendedNotice_link__cHzbr"};